import { ADDRESSES_GET } from '../actions/types';

const initialState = {
  items: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADDRESSES_GET._SUCCESS: {
      const { userId, addresses } = action.payload;
      state.items[userId] = addresses;
      return state;
    }

    default:
      return state;
  }
};

export { reducer as addresses };
